var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 41,
    viewBox: "0 8 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 16.8571C13.7143 17.0982 13.5268 17.2857 13.2857 17.2857H7.28571C7.04464 17.2857 6.85714 17.0982 6.85714 16.8571V14.7143C6.85714 14.4732 7.04464 14.2857 7.28571 14.2857H8.57143V10H7.28571C7.04464 10 6.85714 9.8125 6.85714 9.57143V7.42857C6.85714 7.1875 7.04464 7 7.28571 7H11.5714C11.8125 7 12 7.1875 12 7.42857V14.2857H13.2857C13.5268 14.2857 13.7143 14.4732 13.7143 14.7143V16.8571ZM12 4.85714C12 5.09821 11.8125 5.28571 11.5714 5.28571H9C8.75893 5.28571 8.57143 5.09821 8.57143 4.85714V2.71428C8.57143 2.47321 8.75893 2.28571 9 2.28571H11.5714C11.8125 2.28571 12 2.47321 12 2.71428V4.85714ZM20.5714 10.4286C20.5714 4.75 15.9643 0.142856 10.2857 0.142856C4.60714 0.142856 0 4.75 0 10.4286C0 16.1071 4.60714 20.7143 10.2857 20.7143C15.9643 20.7143 20.5714 16.1071 20.5714 10.4286Z",
    fill: "#EF533F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info_red.c706dbb5c09015d70d2e533ac030bcd5.svg";
export { ForwardRef as ReactComponent };